export default "__VITE_ASSET__Dhk5MJUt__"